import { Meta } from "@/components/meta/Meta"
import { BreadcrumbWithCover } from "@/layout/BreadcrumbWithCover"
import { InfoAndQuestion } from "@/modules/infoAndService/components/InfoAndQuestion"
import { GetPageData } from "@/modules/type"
import { Container } from "@mantine/core"
import { FC } from "react"

interface Props {
  page: GetPageData
}

export const InfoAndService: FC<Props> = ({ page }) => {
  return (
    <>
      <Meta data={page?.attributes?.seo!} />
      <BreadcrumbWithCover
        cover={page?.attributes?.seo?.metaImage?.data?.attributes?.url}
        title={page?.attributes?.title!}
        breadcrumbs={[{ title: page?.attributes?.title!, url: "/faqs" }]}
      />
      <Container mt={48} mb={110}>
        <InfoAndQuestion />
      </Container>
    </>
  )
}
